import * as i0 from "@angular/core";
var CompatibilityService = /** @class */ (function () {
    function CompatibilityService() {
    }
    CompatibilityService.prototype.supportsWebGl = function () {
        // Create canvas element. The canvas is not added to the document itself, so it is never displayed in the
        // browser window.
        var canvas = document.createElement('canvas');
        // Get WebGLRenderingContext from canvas element.
        var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        // Report the result.
        return (gl && gl instanceof WebGLRenderingContext);
    };
    CompatibilityService.ngInjectableDef = i0.defineInjectable({ factory: function CompatibilityService_Factory() { return new CompatibilityService(); }, token: CompatibilityService, providedIn: "root" });
    return CompatibilityService;
}());
export { CompatibilityService };
